import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=005d71d3&scoped=true&"
import script from "./NewMessage.vue?vue&type=script&lang=ts&"
export * from "./NewMessage.vue?vue&type=script&lang=ts&"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=005d71d3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d71d3",
  null
  
)

export default component.exports